


































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";
import DateFormatter from "../../../shared/DateFormatter";
import OverlayWindow from "../../general/OverlayWindow.vue";
import Loading from "../../general/Loading.vue";
import PointerMenu from "../../general/PointerMenu.vue";
import ExpandableView from "../../controls/ExpandableView.vue";
import ImageSelectBase64 from "../../general/ImageSelectBase64.vue";

import { SettingsPublicJson } from "../../../shared/SettingsJson";
import ClientJson from "../../../shared/ClientJson";
import RentalBookingJson, {
  defaultRentalBookingJson,
  getRentalBookingTotalPrice,
} from "../../../shared/RentalBookingJson";
import RentalConditionJson, {
  defaultRentalConditionJson,
  getRentalConditionPrice,
} from "../../../shared/RentalConditionJson";
import RentalAccountJson, { defaultRentalAccountJson } from "../../../shared/RentalAccountJson";
import { RentalBookingStatus, RentalBookingStatusNames } from "../../../shared/RentalBookingStatus";
import RentalItemJson, { defaultRentalItemJson } from "../../../shared/RentalItemJson";
import CustomerJson, { defaultCustomerJson } from "../../../shared/CustomerJson";
import SepaMandateJson from "../../../shared/SepaMandateJson";
import { Gender } from "../../../shared/Gender";
import TableView, { TableViewColumnDefinitions } from "../../controls/TableView.vue";
import PriceUtils from "../../../shared/PriceUtils";

import { ValidationResult, Validation, ValidationErrorType } from "../../../shared/Validation";
import {
  validateRentalBookingJson,
  validateRentalBookingJsonAdd,
  validateRentalBookingJsonRequest,
  validateRentalBookingJsonAccountRequest,
} from "../../../shared/RentalBookingJson";

import FormCustomer from "../../general/FormCustomer.vue";
import FormSepaMandate from "../../general/FormSepaMandate.vue";
import ApprovalList from "../../../components/controls/ApprovalList.vue";
import RentalBookingAdditionalConditions from "./RentalBookingAdditionalConditions.vue";

import CustomContent from "../../../components/custom/RentalRegistration";

export default Vue.extend({
  name: "RentalRequestBooking",
  components: {
    OverlayWindow,
    Loading,
    PointerMenu,
    ExpandableView,
    TableView,
    FormCustomer,
    FormSepaMandate,
    ImageSelectBase64,
    ApprovalList,
    RentalBookingAdditionalConditions,
  },
  props: {
    settings: Object as PropType<SettingsPublicJson | null>,
    clientData: Object as PropType<ClientJson>,
    clientPassword: String,
    restrictToTypeId: Number as PropType<number | null>,
    rentalCart: Array as PropType<RentalBookingJson[]>,
  },
  data() {
    return {
      RestClient: RestClient,
      DateFormatter: DateFormatter,
      Gender: Gender,
      CustomContent: CustomContent,
      getRentalConditionPrice: getRentalConditionPrice,
      getRentalBookingTotalPrice: getRentalBookingTotalPrice,
      RentalItemDefaultData: defaultRentalItemJson(),
      RentalBookingDefaultData: defaultRentalBookingJson(),
      RentalConditionDefaultData: defaultRentalConditionJson(),
      RentalAccountDefaultData: defaultRentalAccountJson(),
      CustomerDefaultData: defaultCustomerJson(),
      RentalBookingStatus: RentalBookingStatus,
      RentalBookingStatusNames: RentalBookingStatusNames,
      supportsDatePicker: false,
      editable: true,
      detailsTitle: "Ausleihen abschließen",
      generalBookingDetails: null as RentalBookingJson | null,
      bookingRentalItems: [] as RentalBookingJson[],
      rentalCartTotalPrice: 0 as number,
      rentalCartTotalPriceExclVAT: 0 as number,
      differentAddress: false as boolean,
      hasChanges: false,
      toValidate: {} as any,
      validation: [] as ValidationResult<RentalBookingJson>[],
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    init() {
      this.bookingRentalItems = this.rentalCart;
      this.loadGeneralBookingDetails();
      this.calcRentalCartTotalPrices();
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    calcRentalCartTotalPrices() {
      this.rentalCartTotalPrice = 0;

      if (this.rentalCart.length > 0) {
        let i: RentalBookingJson;
        for (i of this.rentalCart) {
          let price = getRentalConditionPrice(i.rentalCondition, i.amount, new Date(i.beginDate), new Date(i.endDate));
          this.rentalCartTotalPrice += price;
          this.rentalCartTotalPriceExclVAT += PriceUtils.getPriceExcludingVAT(
            price,
            i.rentalCondition.priceIncludedVATRate
          );

          for (let c of i.additionalRentalConditions) {
            price = getRentalConditionPrice(c, i.amount, new Date(i.beginDate), new Date(i.endDate));
            //price = getRentalAdditionalConditionPrice(c);
            this.rentalCartTotalPrice += price;
            this.rentalCartTotalPriceExclVAT += PriceUtils.getPriceExcludingVAT(price, c.priceIncludedVATRate);
          }
        }
      }
    },

    loadGeneralBookingDetails() {
      this.generalBookingDetails = this.RentalBookingDefaultData;
      this.generalBookingDetails.isVATExempt = null;

      //customer
      this.generalBookingDetails.customer = this.CustomerDefaultData;

      //SEPA
      if (this.clientData != null && this.clientData.sepaMandate) {
        this.generalBookingDetails.sepaMandate = null;
      } else {
        //this.generalBookingDetails.sepaMandate = this.getDefaultSepaMandate();
        this.generalBookingDetails.sepaMandate = null; //SJR Erlangen
      }

      this.setClientData();
      this.setSepaAddress();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      return {
        ID: null,
        dateTime: new Date().toISOString(),
        lastUseDateTime: new Date().toISOString(),
        accountHolderFirstName: "",
        accountHolderLastName: "",
        addressStreet: "",
        addressZip: "",
        addressCity: "",
        addressCountry: "",
        IBAN: "",
        BIC: "",
      };
    },

    setClientData() {
      if (
        this.clientData != null &&
        this.clientData.contact != null &&
        this.generalBookingDetails != null &&
        this.generalBookingDetails.customer != null
      ) {
        this.generalBookingDetails.customer.guardianOrganisation = this.clientData.contact.organisation;
        this.generalBookingDetails.customer.guardianFirstName = this.clientData.contact.firstName;
        this.generalBookingDetails.customer.guardianLastName = this.clientData.contact.lastName;
        this.generalBookingDetails.customer.email = this.clientData.contact.email;
        this.generalBookingDetails.customer.phone = this.clientData.contact.phone;
        this.generalBookingDetails.customer.addressStreet = this.clientData.contact.addressStreet;
        this.generalBookingDetails.customer.addressZip = this.clientData.contact.addressZip;
        this.generalBookingDetails.customer.addressCity = this.clientData.contact.addressCity;
        this.generalBookingDetails.customer.addressCountry = this.clientData.contact.addressCountry;
        this.generalBookingDetails.customer.idDocuments = [ ...this.clientData.contact.idDocuments ];
      }
    },

    setSepaAddress() {
      if (
        this.generalBookingDetails != null &&
        this.generalBookingDetails.customer != null &&
        this.generalBookingDetails.sepaMandate != null
      ) {
        this.generalBookingDetails.sepaMandate.accountHolderFirstName = this.differentAddress
          ? ""
          : this.generalBookingDetails.customer.guardianFirstName;
        this.generalBookingDetails.sepaMandate.accountHolderLastName = this.differentAddress
          ? ""
          : this.generalBookingDetails.customer.guardianLastName;
        this.generalBookingDetails.sepaMandate.addressStreet = this.differentAddress
          ? ""
          : this.generalBookingDetails.customer.addressStreet;
        this.generalBookingDetails.sepaMandate.addressZip = this.differentAddress
          ? ""
          : this.generalBookingDetails.customer.addressZip;
        this.generalBookingDetails.sepaMandate.addressCity = this.differentAddress
          ? ""
          : this.generalBookingDetails.customer.addressCity;
        this.generalBookingDetails.sepaMandate.addressCountry = this.generalBookingDetails.customer.addressCountry;
      }
    },

    //START set cached data

    //END set cached data

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.generalBookingDetails != null) {
        this.validation[0] = validateRentalBookingJsonRequest(this.generalBookingDetails, this.settings?.rentalRequestPickupAndReturnTime, this.bookingRentalItemNeedsIdDocument);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    addGeneralBookingDetails() {
      if (this.rentalCart != null && this.generalBookingDetails != null) {
        for (let i of this.rentalCart) {
          i.customer = this.generalBookingDetails.customer;
          i.sepaMandate = this.generalBookingDetails.sepaMandate;
        }
      }
    },

    async sendBooking() {
      if (this.rentalCart != null && this.generalBookingDetails != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        if (!this.differentAddress) {
          this.setSepaAddress();
        }

        for (let i = 0; i < this.rentalCart.length; i++) {
          this.rentalCart[i].isVATExempt = this.generalBookingDetails.isVATExempt;
          this.rentalCart[i].remarksVATExemption = this.generalBookingDetails.remarksVATExemption;
          this.rentalCart[i].bookingDateTime = new Date().toISOString();
          this.rentalCart[i].customer = this.generalBookingDetails.customer;
          this.rentalCart[i].sepaMandate = this.generalBookingDetails.sepaMandate;
          if (this.rentalCart[i].rentalItem != null) {
            this.rentalCart[i].rentalItem!.description = null;
          }

          if (this.clientData != null) {
            this.validation[i] = validateRentalBookingJsonAccountRequest(this.rentalCart[i], this.settings?.rentalRequestPickupAndReturnTime, this.bookingRentalItemNeedsIdDocument);
          } else {
            this.validation[i] = validateRentalBookingJsonRequest(this.rentalCart[i], this.settings?.rentalRequestPickupAndReturnTime, this.bookingRentalItemNeedsIdDocument);
          }

          if (!(this.$refs.approvalRequired as any).validate() || this.validation[i].isValid == false) {
            this.loadingGeneral = false;
            alert("Die Buchung konnte nicht durchgeführt werden. Bitte prüfen Sie Ihre Eingaben.");
            return;
          }
        }

        if (this.clientData != null && this.clientPassword != null) {
          try {
            let res = await this.RestClient.requestRentalBookingsRentalAccount(
              this.rentalCart,
              this.clientData.username ?? "",
              this.clientPassword,
              this.restrictToTypeId
            );
            alert("Die Buchung wurde erfolgreich übermittelt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.$emit("emptyCart");
              this.closeDetails();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          try {
            console.log(this.restrictToTypeId);
            let res = await this.RestClient.requestRentalBookings(this.rentalCart, this.restrictToTypeId);
            alert("Die Buchung wurde erfolgreich übermittelt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.$emit("emptyCart");
              this.closeDetails();
            });
          } catch (e) {
            this.loadingGeneral = false;

            if (e.hasOwnProperty("validationResult")) {
              if (
                e.validationResult.errors.customer != null &&
                e.validationResult.errors.customer.email == ValidationErrorType.domainLookupFailed
              ) {
                alert("Die eingegebene E-Mail Adresse ist nicht gültig. Bitte prüfen Sie auf Tippfehler.");
              } else {
                alert(e.message);
              }
            } else {
              alert(e.message);
            }
          }
        }
      }
    },

    filterRentalConditionsOnlyManagement(conditions: RentalConditionJson[]): RentalConditionJson[] {
      return conditions.filter((i: RentalConditionJson) => i.isManagementOnly);
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    generalBookingDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },

    differentAddress() {
      this.setSepaAddress();
    },
  },

  computed: {
    rentalItemsColumns: function (): TableViewColumnDefinitions<RentalBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Produkt",
          td: (i) => i.rentalItem?.name,
        },
        {
          th: "Anzahl",
          td: (i) => i.amount,
        },
        {
          th: "Zeitraum",
          td: (i) =>
            vue.DateFormatter.formatWeekdayDate(new Date(i.beginDate)) +
            " – " +
            vue.DateFormatter.formatWeekdayDate(new Date(i.endDate)),
        },
        {
          th: "Preiskategorie",
          td: (i) => i.rentalCondition?.title + " | " + vue.getFormatPrice(i.rentalCondition?.price) + " €",
        },
        {
          th: "Zusätzliche Optionen",
          td: (i) =>
            i.additionalRentalConditions.length > 0
              ? i.additionalRentalConditions.map((c) => c.title).join(", ")
              : "Keine ausgewählt",
        },
        /* {
          th: "Einzelpreis",
          td: (i) =>
            "€ " +
            vue.getFormatPrice(
              vue.getRentalConditionPrice(i.rentalCondition, 1, new Date(i.beginDate), new Date(i.endDate))
            ),
        }, */
        {
          th: "Preis",
          td: (i) =>
            "€ " +
            vue.getFormatPrice(
              //vue.getRentalConditionPrice(i.rentalCondition, i.amount, new Date(i.beginDate), new Date(i.endDate))
              vue.getRentalBookingTotalPrice(i).priceIncludingVAT
            ),
        },
      ] as TableViewColumnDefinitions<RentalBookingJson>[];
    },

    bookingRentalItemNeedsIdDocument: function (): boolean {
      if(this.bookingRentalItems) {
        return this.bookingRentalItems.some((i: RentalBookingJson) => i.rentalItem ? (i.rentalItem.requestDriversLicense == true) : false);
      } else {
        return false;
      }
    }
  },
});
